// @flow

import React, { Component } from "react";

import PostWidgetChatBubble from "./post-widget-chat-bubble";
import PostWidgetInfoSection from "./post-widget-info-section";
import RadioHierarchyTree from "../../radio-hierarchy-tree";
import type { RadioWidget as RadioWidgetProps } from "react-jsonschema-form/lib/components/widgets/RadioWidget";

type Props = $Exact<{
  ...RadioWidgetProps,
  options: Object,
}>;

class RadioHierarchyTreeWidget extends Component<Props> {
  handleChange = (value: any): void => {
    this.props.onChange(value);
  };

  render() {
    return (
      <React.Fragment>
        <RadioHierarchyTree
          searchable={!!this.props.options.searchable}
          searchPlaceholder={this.props.options.searchPlaceholder}
          tree={this.props.schema.tree}
          selected={this.props.value}
          disabled={this.props.readonly}
          onChange={this.handleChange}
          expanded={[]}
        />
        <PostWidgetChatBubble options={this.props.options} />
        <PostWidgetInfoSection options={this.props.options} />
      </React.Fragment>
    );
  }
}

export default RadioHierarchyTreeWidget;
